import type {FunctionComponent} from 'preact';
import {useMemo, useReducer} from 'preact/hooks';

import {AuthorizeContext} from './context';
import {authorizeReducer, initialAuthorizeState} from './reducer';

export const AuthorizeProvider: FunctionComponent = ({children}) => {
  const [state, dispatch] = useReducer(authorizeReducer, initialAuthorizeState);

  const value = useMemo(() => {
    return {
      dispatch,
      state,
    };
  }, [state]);

  return (
    <AuthorizeContext.Provider value={value}>
      {children}
    </AuthorizeContext.Provider>
  );
};
